import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import StocksCandlestickCharts from "./StocksCandlestickCharts/StocksCandlestickCharts";
import MobileLiveTradeSideBar from "../MobileLiveTradeSideBar/MobileLiveTradeSideBar";

const MobileStockLiveTrade = ({ data }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <>
      <div className="d-flex justify-content-evenly align-items center  trade-page-btn">
        <div className="row gutters">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="text-center">
              <Link to={`/user/trade/hot/${data?._id}`} className="user-btn1  ">
                Binary Trade
              </Link>
            </div>
          </div>
        </div>

        <div className="row gutters">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="text-center">
              <Link className="user-btn1  active">Live Trade</Link>
            </div>
          </div>
        </div>
      </div>
      <StocksCandlestickCharts TradeData={data} setShow={setShow} />
      <Offcanvas
        show={show}
        onHide={handleClose}
        className="mobile-trade-offcanvas-area"
      >
        <MobileLiveTradeSideBar
          handleClose={handleClose}
        ></MobileLiveTradeSideBar>
      </Offcanvas>
    </>
  );
};

export default MobileStockLiveTrade;
